import {  createTheme } from "@mui/material/styles";

const muiCustomTheme = createTheme({
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: "none",
                },
                outlined: {
                    border: "1px solid #3EAE54",
                    color: "#3EAE54",
                    "&:hover": {
                        border: "1px solid #3EAE54",
                        backgroundColor: "rgba(62, 174, 84, 0.1)",
                    },
                    "&:active": {
                        border: "1px solid #3EAE54",
                        backgroundColor: "rgba(62, 174, 84, 0.2)",
                    },
                },
                contained: {
                    backgroundColor: "#3EAE54",
                    color: "#FFFFFF",
                    "&:hover": {
                        backgroundColor: "#349245",
                    },
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    color: "#000",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                },
            },
        },
    },
});

export default muiCustomTheme;